import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SpotToast } from "@/components/SpotToast";
import { TagsService } from "@/generated";
import { DATA_KEYS } from "@/utils/useRemoteData";

const TAG_QUERY_KEYS = [
  DATA_KEYS.TAGS,
  DATA_KEYS.WORKFLOWS,
  DATA_KEYS.ASSISTANTS,
  DATA_KEYS.KNOWLEDGE_BASES_V2,
  DATA_KEYS.TABLES,
];

export const useTagMutations = ({ onSettled }: { onSettled?: () => void }) => {
  const queryClient = useQueryClient();
  const invalidateTagged = () =>
    TAG_QUERY_KEYS.forEach((key) =>
      queryClient.invalidateQueries({ queryKey: [key] })
    );

  const editTag = useMutation({
    mutationFn: TagsService.updateTag,
    onSuccess: () => {
      invalidateTagged();
      SpotToast.success("Tag updated successfully!");
    },
    onError: (error) => {
      if ((error as any)?.response?.status === 409) {
        SpotToast.error(
          (error as any)?.response?.data?.message ||
            "Error updating tag. Please try again later."
        );
      } else {
        SpotToast.error("Error updating tag. Please try again later.");
      }
    },
    onSettled,
  });

  const deleteTag = useMutation({
    mutationFn: TagsService.deleteTag,
    onSuccess: () => {
      invalidateTagged();
      SpotToast.success("Tag deleted successfully!");
    },
    onError: () => SpotToast.error("Error deleting tag"),
    onSettled,
  });

  return { editTag, deleteTag };
};
